import React, { useState } from 'react'
import { useMutation, useQueryClient } from 'react-query';
import { Link, useNavigate, useLocation, useParams } from 'react-router-dom';
import {
    searchPortalMember,
    createPortalUser
} from "../../../api/apiServices";

import toast, { Toaster } from 'react-hot-toast'
import UserRoles from '../../../hooks/userRoles';
import useAuth from "../../../hooks/useAuth";
import jwt_decode from "jwt-decode";


const CreatePortalUser = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/";

    const { auth } = useAuth();
    const decoded = auth?.accessToken
        ? jwt_decode(auth.accessToken)
        : undefined

    const role = decoded?.UserInfo?.role || ""
    const [search, setSearch] = useState(false);
    const [member, setMember] = useState([]);
    const [pf_number, setPFNumber] = useState("");
    const [email, setEmail] = useState("");

    const [data, setData] = useState({
        pf_number: "",
        first_name: "",
        middle_name: "",
        last_name: "",
        mobile_number: "",
        email: "",
    })

    const handleSearch = async (e) => {
        e.preventDefault();

        const searchData = {
            pf_number: pf_number.toLocaleUpperCase(),
            email: email,
        }
        searchMutation.mutate(searchData)
    }

    const searchMutation = useMutation(searchPortalMember, {
        onSuccess: async (res) => {
            setMember(res)

            setData({
                pf_number: res[0].pf_number,
                first_name: res[0].first_name,
                middle_name: res[0].middle_name,
                last_name: res[0].last_name,
                email: res[0].email,
                mobile_number: res[0].mobile_number,
            })
            setSearch(true)
        }
    })

    const handleCancel = () => {
        setPFNumber("");
        setEmail("");
        setSearch(false);
        // navigate(from, { replace: true });
    }

    const handleCreate = () => {
        if (role === UserRoles.SuperAdmin || role === UserRoles.SystemAdmin) {
            const portalUserData = {
                pf_number: data.pf_number,
                first_name: data.first_name,
                middle_name: data.middle_name,
                last_name: data.last_name,
                email: data.email,
                mobile_number: data.mobile_number,
            }

            createPortalUserMutation.mutate(portalUserData)
        } else {
            toast.error("You are not authorized to perform this function. Contact the System Administrator", {
                duration: 3000,
                className: "toast-message"
            });
            return false
        }
    }

    const createPortalUserMutation = useMutation(createPortalUser, {
        onSuccess: async (res) => {
            if (res.success) {
                toast.success(res.message, {
                    duration: 5000,
                    className: "toast-message",
                });                
            } else {
                toast.error(res.message, {
                    duration: 5000,
                    className: "toast-message",
                });                                
            }
            setSearch(false);
        },
        onError: async (err) => {
            toast.error(err.message, {
                duration: 5000,
                className: "toast-message",
            });
            setSearch(false);
        }
    })


    let searchContent = (
        <form onSubmit={handleSearch} >
            <div className="form-group row">
                <div className="col-sm-5">
                    <input
                        className="form-control"
                        type="text"
                        placeholder="PF Number"
                        style={{ textTransform: "uppercase", fontSize: "14px" }}
                        onChange={(e) => setPFNumber(e.target.value)}
                        value={pf_number}
                    />
                </div>
                <div className="col-sm-5">
                    <input
                        type="email"
                        className="form-control"
                        placeholder="Email Address"
                        style={{ fontSize: "16px" }}
                        onChange={(e) => setEmail(e.target.value)}
                        value={email}
                    />
                </div>
                <div className="col-sm-2">
                    <button
                        type="submit"
                        className="btn btn-success btn-block"
                    > <i className="fa fa-search"></i> Search</button>
                </div>
            </div>
        </form>
    )
    let content
    if (search) {
        content = member && member?.length <= 0 ? (
            <div className="table-responsive lg">
                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td style={{ fontSize: "20px", fontWeight: "700", color: "#000", textAlign: "center" }}>
                                No member found with the requested parameter(s)
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        ) : (
            <div className='table-responsive lg'>
                <table className="table table-borderless table-hover table-striped">
                    <thead className="align">
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">PF Number</th>
                            <th scope="col">Full Name</th>
                            <th scope="col">Region</th>
                            <th scope="col">Mobile Number</th>
                            <th scope="col">Email</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {member?.map((mem, index) =>
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{mem.pf_number}</td>
                                <td style={{ whiteSpace: 'nowrap' }}>{mem.first_name.toUpperCase()}&nbsp;{mem.middle_name.toUpperCase()}&nbsp;{mem.last_name.toUpperCase()}</td>
                                <td style={{ whiteSpace: 'nowrap' }}>{mem.region}</td>
                                <td style={{ whiteSpace: 'nowrap' }}>{mem.email}</td>
                                <td>{mem.mobile_number}</td>
                                <td style={{ whiteSpace: 'nowrap' }}>
                                    <div style={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
                                        <button onClick={handleCreate} className="btn btn-danger"><i className='fa fa-plus'></i> Create</button>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        )
    }
    return (
        <>
            <section className="content-header">
                <Toaster toastOptions={{ position: "top-center" }} />
                <h1>Create Portal User</h1>
            </section>
            <section className="content">
                <div className="box">
                    <div className="box-body">
                        <div className="panel panel-default panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h4 className="panel-title">
                                            {searchContent}
                                        </h4>
                                    </div>
                                </div>
                            </div>

                            <div className="panel-body">
                                {content}
                            </div>
                            {search ?
                                <div className="panel-footer">
                                    <div className="search-group">
                                        <button
                                            type="submit"
                                            className="btn btn-danger "
                                            onClick={handleCancel}
                                        > <i className="fa fa-search"></i> Cancel</button>
                                    </div>
                                </div>
                                : null}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default CreatePortalUser;


